"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAccount = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var OpenAccount = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(OpenAccount, _super);
    function OpenAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '开通基金账户';
        _this.code = '106004';
        _this.desc = '开通基金账户';
        _this.requestParams = new zl_1.OpenAccountRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return OpenAccount;
}(service_1.BaseService));
exports.OpenAccount = OpenAccount;
//# sourceMappingURL=openAccount.js.map